// NATIVE 


// INSTALLED 

// CUSTOM 
import { AxiosAdapter } from "../commons/adapters";
import { closeSessionGlobal } from "../commons/utils";


const http = new AxiosAdapter();





export const getCompanyServices = async() => {
   
    try {
        
        return await http.get<any>('/v1/company/company'); 

    } catch (error:any) {

        

        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('getDataFormInputsServiceCompany ',error);

    }
}



export const getDataFormInputsServiceCompany = async() => {
   
    try {
        
        return await http.get<any>('/v1/company/data-form-inputs'); 

    } catch (error:any) {

        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('getDataFormInputsServiceCompany ',error);

    }
}



export const saveCompanyService = async(company:object, setPercentajeCCompany:any) => {
   
    try {
        
        return await http.post<any>('/v1/company', company, setPercentajeCCompany); 

    } catch (error:any) {
        
        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('saveCompanyService ',error);

    }
}



export const editCompanyService = async(company:object) => {
   
    try {
        
        return await http.put<any>('/v1/company', company); 

    } catch (error:any) {
        
        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('editCompanyService ',error);

    }
}




export const getCompanyDetailService = async(companyId:string, setPercentajeCCompany:any) => {
   
    try {

        
        return await http.get<any>(`/v1/company/${companyId}`); 

    } catch (error:any) {
        
        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('getCompanyDetailService ',error);

    }
}




export const getCompanyDataSelectsService = async() => {
   
    try {
        
        return await http.get<any>('/v1/company/data-create-form-inputs'); 

    } catch (error:any) {
        
        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('getCompanyDataSelectsService ',error);

    }
}




export const desactiveCompanyDetailService = async(companyId:string, setPercentajeCCompany:any) => {
   
    try {
        
        return await http.delete<any>(`/v1/company/${companyId}`); 

    } catch (error:any) {
        
        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('desactiveCompanyDetailService ',error);

    }
}



export const activeCompanyDetailService = async(companyId:string, setPercentajeCCompany:any) => {
   
    try {
        
        return await http.patch<any>(`/v1/company/${companyId}`); 

    } catch (error:any) {
        
        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('activeCompanyDetailService ',error);

    }
}